import script from "./SampleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleCard.vue?vue&type=script&setup=true&lang=js"

import "./SampleCard.vue?vue&type=style&index=0&id=0494568e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0494568e"]])

export default __exports__